/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { StyledIconButton, StyledIconButtonLabel, StyledIconButtonContainer } from './index.styles.js';
import { Icon } from '../icon/index.js';
import { ProgressIndicator } from '../progress-indicator/index.js';
import {} from '@oneaudi/unified-web-common';
export const progressIndicatorSize = {
    md: 56,
    sm: 'lg'
};
export const progressIndicatorVariant = {
    primary: 'inverted',
    secondary: 'idle',
    tertiary: 'idle'
};
export const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const IconButton = forwardRef((props, ref) => {
    const { variant, icon, size, 'aria-label': ariaLabel, className, 'data-testid': dataTestId, id, label, isLoading, title, margin } = props;
    const labelId = `${id}_label`;
    const baseProps = {
        variant,
        ref,
        size,
        'aria-label': ariaLabel,
        'data-testid': dataTestId,
        className,
        title,
        margin,
        id,
        label,
        isLoading
    };
    const content = (React.createElement(React.Fragment, null, isLoading ? (React.createElement(ProgressIndicator, { variant: "spinner", type: "infinite", colorScheme: progressIndicatorVariant[variant], size: progressIndicatorSize[size] })) : (React.createElement(Icon, { name: icon, size: "s" }))));
    return (React.createElement(StyledIconButtonContainer, { variant: variant, className: className, isLoading: isLoading, margin: margin },
        hasHref(props) ? (React.createElement(StyledIconButton, { ...baseProps, as: "a", href: props.href, rel: props.rel, target: props.target, onClick: props.onClick, "aria-labelledby": label && labelId }, content)) : (React.createElement(StyledIconButton, { ...baseProps, as: "button", "aria-labelledby": label && labelId, "aria-disabled": props.disabled, "aria-controls": props['aria-controls'], "aria-expanded": props['aria-expanded'], "aria-haspopup": props['aria-haspopup'], onClick: props.onClick, disabled: props.disabled, type: props.type }, content)),
        label && (React.createElement(StyledIconButtonLabel, { size: size, id: labelId }, label))));
});
IconButton.displayName = 'IconButton';
//# sourceMappingURL=index.js.map